import React from 'react';
import { SeoIcon } from './seoIcons';
import './seo-content-grid.css';

export const SeoContent = ({ children, className = '' }) => (
  <section className={`seo-content ${className}`.trim()}>
    <div className="container">
      <article className="seo-article seo-article-layout">{children}</article>
    </div>
  </section>
);

export const SeoIntro = ({ children }) => <div className="seo-intro">{children}</div>;

export const SeoSectionsGrid = ({ children }) => (
  <div className="seo-sections-grid">{children}</div>
);

export const SeoSection = ({ icon = 'server', title, children, wide = false }) => (
  <div className={`seo-section-card${wide ? ' seo-section-card--wide' : ''}`}>
    <div className="seo-section-icon-wrap" aria-hidden="true">
      <SeoIcon name={icon} />
    </div>
    <div className="seo-section-body">
      {title ? <h3 className="seo-section-title">{title}</h3> : null}
      <div className="seo-section-text">{children}</div>
    </div>
  </div>
);

export const SeoOutro = ({ children }) => <div className="seo-outro">{children}</div>;
